<template>
  <div>
    <headerTop></headerTop>
    <div class="box">
      <div style="border-bottom: 3px solid #377CF1;padding-bottom:26px">
        <div class="logo">
          <img src="@/assets/images/home/AIRPLEX.png" alt="" />
        </div>
        <span style="margin-right:23px;margin-left:12px;font-size: 20px;font-weight:bold;color: #505050;">确认商品</span>
        <span style="font-size: 20px;color: #8B8C94;">正见·正心·正品</span>
      </div>
      <div class="top">
        <span class="top-1"> 确认收货地址 </span>
        <span class="top-2" @click="addAddress">+新增收货地址</span>
      </div>
      <div>
        <vxe-table
          row-id="preferred"
          ref="xTable1"
          :show-header="false"
          :data="tableDataAddress"
          :radio-config="{ checkRowKey: defaultSelecteRow }"
          @radio-change="radioChangeEvent"
        >
          <vxe-column type="radio" width="60"> </vxe-column>
          <vxe-column field="name" width="100" title="Sex"></vxe-column>
          <vxe-column field="phone" width="150" title="Age"></vxe-column>
          <vxe-column
            field="fullAddress"
            title="Address"
            show-overflow
          ></vxe-column>
          <vxe-column width="100" field="phone">
            <template v-slot="{ row }">
              <span v-if="row.preferred === 1">
               <span style="font-size:12px;background-color:#E7E7E9;padding:5px"> 默认地址</span>
              </span>
            </template>
          </vxe-column>
          <vxe-column title="Address" width="100" show-overflow>
            <template v-slot="{ row }">
              <vxe-button
                type="text"
                status="primary"
                style="color:#377CF1"
                @click="insertRow(row, 'current')"
                >修改地址</vxe-button
              >
            </template>
          </vxe-column>
        </vxe-table>
        <div
          v-if="more != length"
          style="color: skyblue"
          @click="moreAddresses"
        >
          更多地址
        </div>
      </div>

      <div style="margin-top: 20px">
        <div class="title">确认订单信息</div>
        <div class="t-top" style="border: 1px solid #eee;">
          <div class="sp">基本信息</div>
          <div class="fh">发货地</div>
          <div class="dj">单价（元）</div>
          <div class="sl">购买数量</div>
          <div class="xj">小计（元）</div>
        </div>

        <div class="table">
          <div
            class="table-top"
            v-for="(item, index) in tableData"
            :key="index"
          >
            <div
              style="
                border-right: 1px solid #eee;
                border-left: 1px solid #eee;
                padding-left:50px;
              "
            >
            <!-- <span style="color:#FF8800;border:1px solid #FF8800;padding:0 2px;margin-right:16px;font-size:12px">佳配自营</span> -->
            <!-- <span style="color:#FF8800;margin-right:5px" class="iconfont icon-a-zu248"></span> -->
            <span class="iconfont icon-shangcheng" style="margin-right:4px"></span>
            <span style="color: #505050;font-weight: 700;margin-right:16px">{{ item.shopName }}</span>
              <xiaopei :oppositeTenantId="item.tenantId">
                <i class="iconfont icon-a-lujing162"></i>
              </xiaopei>
            </div>
            <div
              class="children"
              v-for="(children, index) in item.children"
              :key="index"
            >
              <div class="img">
                <img v-if="children.pictureUrl" :src="children.pictureUrl" alt="" />
                <img v-else src="https://img.g-part.cn/prod/wss/default_null.png" alt="" />
              </div>
              <div class="pjname">
                <!-- <span v-if="children.shopName" style="padding-top:20px;display: inline-block;height:20px;">{{children.shopName}}</span>
                 <xiaopei :oppositeTenantId="children.tenantId"  v-if="children.shopName">
                  <i class="iconfont icon-a-lujing162"></i>
                 </xiaopei>
                <br> -->
                <span class="ycj" v-if="children.qualityType">{{
                  children.qualityType
                }}</span>
                <span class="ad">
                  {{ children.partComplexName }}
                </span>          
              </div>
              <div class="fhaddres">{{ children.shipCity || '--' }} {{ children.shipStore || '--' }}</div>
              <div class="dprice">
                <span >￥</span>
                <span style="font-size: 18px;  font-weight: 700">{{
                  children.realTimePrice
                }}</span>
              </div>
              <div class="snumber">{{ children.partNum }}</div>
              <div class="xjy">
                <span style="color: red">￥</span>
                <span style="font-size: 18px; color: red; font-weight: 700">{{
                  children.partCurrentAmount
                }}</span>
              </div>
            </div>
            <div
              style="height: 178px; border: 1px solid #eee; "
            >
              <Form :model="item.formItem" :label-width="100">
                <div style="float: left">
                  <Form-item label="运送方式：">
                    <Radio-group v-model="item.formItem.transportType">
                      <Radio label="1">物流快递</Radio>
                      <Radio label="2">上门自取</Radio>
                      <span class="f-left">邮费默认到付，具体请和卖家联系</span>
                    </Radio-group>
                  </Form-item>
                  <Form-item label="给卖家留言：" style="width: 484px;margin-left:14px">
                    <Input
                      width="104px"
                      v-model="item.formItem.remark"
                      :autosize="{ minRows: 2, maxRows: 5 }"
                      type="textarea"
                      :rows="2"
                      maxlength="200"
                      placeholder="选填，请先和商家协商一致"
                      @on-change="changeInput(item)"
                    > </Input>
                   <span class="Tips">{{item.changeInput}}/200</span>
                  </Form-item>
                </div>
                <div
                  style="
                    left: 10px;
                    margin-top: none;
                    float: right;
                    width: 650px;
                  "
                >
                  <Form-item style="width: 650px;height:100%" class="dasd">
                    <Radio-group v-model="item.formItem.invoiceTitle">
                      <Radio v-if="item.drawABill === '0'" size="small" label="0" style="margin-right: 50px"
                        >不开发票</Radio
                      >
                      <!-- <Radio size="small" label="1" style="margin-right: 50px"
                        >平台发票</Radio
                      > -->
                      <Radio size="small" label="2">供应商发票</Radio>
                    </Radio-group>
                    <span
                      v-if="
                        item.formItem.invoiceTitle === '1' ||
                        item.formItem.invoiceTitle === '2'
                      "
                      class="f-left"
                      >开票金额不包含运费</span
                    >
                  </Form-item>
                  <Form-item
                    label="发票类型："
                    v-if="
                      item.formItem.invoiceTitle === '1' ||
                      item.formItem.invoiceTitle === '2'
                    "
                  >
                    <Radio-group v-model="item.formItem.invoiceType">
                      <Radio size="small" label="0"><span class="fplx" style="background-color:#F62B4E">专票</span><span>增值税专用发票</span></Radio>
                      <Radio size="small" label="1"><span class="fplx"  style="background-color:#47C460">普票</span><span>增值税普通发票</span></Radio>
                    </Radio-group>
                  </Form-item>
                </div>
              </Form>
              <div
                class="fpxx"
                v-if="
                  item.formItem.invoiceTitle === '1' ||
                  item.formItem.invoiceTitle === '2'
                "
              >
                发票信息：
                <!-- <div class="zi">{{ item.simpleInvoice[0].invoiceName + item.simpleInvoice[0].invoiceTaxId }}</div> -->
                <span
                  class="Reselect"
                  v-if="
                    (item.simpleInvoice.length > 0 &&
                      item.formItem.invoiceTitle === '2') ||
                    (item.simpleInvoice.length > 0 &&
                      item.formItem.invoiceTitle === '1')
                  "
                  @click="Reselect(item, item.shopId)"
                  >重新选择</span
                >
                <span v-if="item.simpleInvoice.length == 0" style="color:red">请先到个人中心-发票管理中维护发票信息</span>
                <span>{{ item.invoiceName }} {{ item.invoiceTaxId }}</span>
              </div>
            </div>
            <div class="dphj">
              <span> 店铺合计（不含运费）：</span>
              <span style="font-weight: 700;">￥</span>
              <span style="font-weight: 700;font-size:20px">{{ item.shopTotalprice }}</span>
            </div>
          </div>
        </div>
        <div class="buttom-one">
          <div class="allPrice">
            <span style="font-size: 16px"> 应付合计（不含运费）：</span>
            <span class="price"> ￥</span>
            <span style="font-size: 20px;font-weight:700">{{ allPrice }} </span>
          </div>
        </div>
        <!-- <div class="buttom-tow">
          <div class="buttom-sfk"
            >实付款：
            <span style="font-size: 12px; color: red; font-weight: 700"
              >￥</span
            >
            <span style="color: red; font-size: 22px; font-weight: 700">{{
              allPrice
            }}</span>
          </div>
          <div class="buttom-yf">
              <span class="buttom-yf-yf"> 运费 </span>
              运费到付，以卖家发货物流公司为准
          </div>
          <div class="buttom-dz">
            <span class="buttom-dz-ps"> 配送至 </span>
              <Tooltip :content="shippingAddress">
                  {{ shippingAddress }}
              </Tooltip>
          </div>
          <Button class="buttom-tj" :loading="loading" @click="placeOrder">
            <span v-if="!loading">提交订单</span>
            <span v-else style="font-weight: 500;font-size: 13px;"></span>
          </Button>
        </div> -->
        <Affix :offset-bottom="0">
        <div class="buttom-tow">
          <div class="buttom-sfk">
            <span style="font-size: 22px;">实付款：</span>
            <span style="font-size: 12px; color: red; font-weight: 700">￥</span>
            <span style="color: red; font-size: 22px; font-weight: 700">{{allPrice}}</span>
          </div>
          <div class="buttom-yf">
              <span class="buttom-yf-yf"> 运费 </span>
              <span>运费到付，以卖家发货物流公司为准</span>
          </div>
          <div class="buttom-dz">
              <Tooltip placement="top"  max-width="450" :content="shippingAddress" style="text-align: center;">
                <span class="buttom-dz-ps"> 配送至 </span> {{ shippingAddress }}
              </Tooltip>
          </div>         
          <div class="buttom-tj">
            <Button :loading="loading" @click="placeOrder">
              <span v-if="!loading">提交订单</span>
              <span v-else style="font-weight: 500;font-size: 13px;"></span>
            </Button>
          </div>         
        </div>
        </Affix>
      </div>
      <div class="qwer">
        <!-- icon-xiaodengpao -->
        <span class="iconfont icon-xiaodengpao" style="margin:0 4px 0 7px;color:#FF5E00"></span>
        非自营、非联盟商品不能使用挂账，请分开提交订单
      </div>
      <bill-type @hehehe="hehehe" ref="bill"></bill-type>
      <add-address ref="address" @throwName="throwName"></add-address>
    </div>
    <Footer></Footer>
    <FooterP></FooterP>
    <!-- 这个是提示 -->
      <Modal v-model="modalJump" footer-hide :mask-closable="false" title="提示" >
      <div>{{ modalJumpTitle }},请返回购物车重新获取最新价格</div>
      <div class="reminder">
          <Button type="primary" style="margin-right:20px" @click="ok">确定</Button>
          <Button type="default" @click="cancel">取消</Button>
      </div>
    </Modal>
    <slider></slider>
  </div>
</template>

<script>
import billType from './billType.vue'
import addAddress from './addAddress.vue'
import headerTop from '@/views/base/common/header-top.vue'
import xiaopei from '@/views/xiaopei/index.vue'
import FooterP from '@/views/base/common/footer-p.vue'
import Footer from '@/views/base/common/footer.vue'
import slider from '@/views/base/common/slider.vue'
import {
  accountAddress,
  tableListPost,
  information,
  placeOrder,
  partsBuy
} from '@/api/orderInformation/orderInformation.js'
// import { awaken } from '@/api/xiaopei/shout.js'
export default {
  // mixins: [awaken],
  components: {
    billType,
    addAddress,
    headerTop,
    xiaopei,
    FooterP,
    Footer,
    slider
  },
  data() {
    return {
      modalJump:false, // 提示框
      modalJumpTitle:'', // 显示提示的语句
      invoiceInformation: '',
      loading: false,
      more: null,
      acc: [],
      length: null,
      defaultSelecteRow: 1,
      ids: window.sessionStorage.setItem('ids', this.$route.query.ids),
      pid: this.$route.query.pid,
      activityType: this.$route.query.activityType || '',
      tableData: [],
      allPrice: null,
      //   地址数据
      tableDataAddress: [],
      // 当前点击修改的数据
      rows: {},
      // 发票信息
      hhh: '',
      idss: '',
      shippingAddress: '',
      c: {},
      // 地址信息
      addressInformation: {},
      spinShow: true,
      invoiceTaxId: '', // 税号
      invoiceId: '', // id
      invoiceName: ''
    }
  },
  methods: {
    cancel(){
      this.modalJump=false
    },
    // 这个是提示的确认按钮
   ok(){
      history.go(-1)
      this.modalJump=false
    },
    colspanMethod({ row }) {
      if (row.asbs) {
        return { rowspan: 1, colspan: 5 }
      }
    },

    // 重新选择
    async Reselect(rows, id) {
      console.log(rows,id);
      this.$refs.bill.modal1 = true
      this.$refs.bill.tableDatas = rows.simpleInvoice
      this.$refs.bill.isVolice()
      // this.$refs.bill.tableDatas = ''
      this.$refs.bill.shopID = id
      this.billTypeData = rows
    },
    // 新增收货地址
    addAddress() {
      this.$refs.address.address = true
      this.$refs.address.kong()
    },
    // 地址单选
    radioChangeEvent({ row }) {
      this.shippingAddress = row.fullAddress
      this.addressInformation = row
    },

    // 修改地址
    insertRow(row) {
      let c = JSON.parse(JSON.stringify(row))
      this.rows = row
      this.$refs.address.addressformItem = c
      this.$refs.address.echo(c)
    },
    // 获取用户地址
    async accountAddress(num) {
      let params = {}
      let res = await accountAddress(params)
      if (res.status) {
        this.tableDataAddress = res.data.list
        if (num === 2) {
          this.$refs.xTable1.reloadData(this.tableDataAddress)
        }
        let c = this.tableDataAddress.filter((el) => {
          return el.preferred === 1 || el.preferred === 0
        })
        console.log(c);
        if(c.length>0){
        this.shippingAddress = c[0].fullAddress
        this.addressInformation = c[0]
        this.length = this.tableDataAddress.length
        this.more = res.data.total
        }

      }
    },
    throwName() {
      this.accountAddress(2)
    },
    // 更多地址
    async moreAddresses() {
      let params = {}
      params.more = 1
      let res = await accountAddress(params)
      if (res.status) {
        let c = this.tableDataAddress.concat(res.data.list)
        this.tableDataAddress = c
        this.length = this.tableDataAddress.length
        this.more = res.data.total
      }
    },
    // 获取订单页面详情
    async tableList() {
      // if-立即购买跳转的 else购物车页面跳的
      if (this.pid) {
        let params = {}
        params.pid = this.pid
        if(this.activityType === '3'){
          params.activityType = 3
        }
        let res = await partsBuy(params)
        console.log(res,'立即购买');
        if (JSON.stringify(res.data) === '{}') {
          this.$Message.error('程序异常')
          return
        }
        if (res.status) {
          let list = res.data.shoppings
          list.filter(el => {
            console.log(el);
            el.changeInput = 0
            el.formItem = {}
            el.formItem.transportType = '1'
            el.formItem.remark = ''
            if(el.hasInvoice === 1){
              el.formItem.invoiceTitle = '2'
              el.drawABill = '1'
            }else{
              el.formItem.invoiceTitle = '0'
              el.drawABill = '0'
            }
            el.formItem.invoiceType = '0'
            el.formItem.dasds = ''
            el.children.filter(ele =>{
              ele.shopName = el.shopName
            })
          })
          this.tableData = res.data.shoppings
          console.log(this.tableData,'this.tableData1');
          this.allPrice = res.data.totalPrice
        }
      } else {
        // let data = window.sessionStorage.getItem('ids').split(',')
        let params = {}
        let indents =JSON.parse(window.sessionStorage.getItem('indent'))
        // let res = await tableListPost(params, data)
        // if (res.status) {
          let list = indents.shoppings
          list.filter((el) => {
            el.changeInput = 0
            el.formItem = {}
            el.formItem.transportType = '1'
            el.formItem.remark = ''
            if(el.hasInvoice === 1){
              el.formItem.invoiceTitle = '2'
              el.drawABill = '1'
            }else{
              el.formItem.invoiceTitle = '0'
              el.drawABill = '0'
            }
            el.formItem.invoiceType = '0'
            el.formItem.dasds = ''
          })
          this.tableData = indents.shoppings
           console.log(this.tableData,'this.tableData2');
          this.allPrice = indents.totalPrice
        // }
      }
    },
    // 提交订单
    async placeOrder() {
      console.log(this.tableData);
      this.loading = true
      let params = {}
      let arr = this.tableData.some((item)=>{
           return item.formItem.transportType == 1  
      })
      console.log(arr);
      if(arr){
      if(this.$refs.xTable1.getRadioRecord() == null){
        this.$Message.warning('请先选择收货地址')
      }else{
      let data = JSON.parse(JSON.stringify(this.tableData))
      console.log(data);
      this.postOrder(data)
      console.log(data);
      if(this.activityType === '3'){
        params.activityType = 3
      }
      let res = await placeOrder(params, data)
      this.loading = false
       if(res.message.indexOf('10030')!==-1){
        this.modalJump = true
        let cx=res.message.indexOf(',')
        this.modalJumpTitle = res.message.substring(cx+1)
        return
      }
      if (res.status) {
        let c = res.data.list
        if(res.data.list.length){
        this.$router.push({
          path: '/payOrder',
          query: { ordeNumber: JSON.stringify(c) }
        }) 
        }
      } 
      }
      }else{
      // console.log(this.$refs.xTable1.getRadioRecord());
      // if(this.$refs.xTable1.getRadioRecord() == null){
      //   this.$Message.warning('请先选择收货地址')
      // }else{
      let data = JSON.parse(JSON.stringify(this.tableData))
      console.log(data);
      this.postOrder(data)
      console.log(data);
      let res = await placeOrder(params, data)
      this.loading = false
       if(res.message.indexOf('10030')!==-1){
        this.modalJump = true
        let cx=res.message.indexOf(',')
        this.modalJumpTitle = res.message.substring(cx+1)
        return
      }
      if (res.status) {
        let c = res.data.list
        if(res.data.list.length){
        this.$router.push({
          path: '/payOrder',
          query: { ordeNumber: JSON.stringify(c) }
        }) 
        }
      // } 
      }
      }

      this.loading = false
    },
    hehehe(row, hid) {
      this.tableData.filter((el) => {
        if (el.shopId === hid) {
          el.invoiceName = row.invoiceName
          el.invoiceTaxId = row.invoiceTaxId
          el.invoiceId = row.id
          this.invoiceId = el.invoiceId
        }
      })
    },
    postOrder(data) {
      data.filter((el) => {
        el.invoiceTitle = el.formItem.invoiceTitle
        el.invoiceType = el.formItem.invoiceType
        el.remark = el.formItem.remark
        el.transportType = el.formItem.transportType
        el.dasds = el.formItem.dasds
        el.buyShopName = el.shopName
        el.buyShopId = el.shopId
        el.buyTenantId = el.tenantId
        el.receiveAddress = this.shippingAddress
        el.receivePhone = this.addressInformation.phone
        el.receiveName = this.addressInformation.name
        el.provinceId=this.addressInformation.provinceId
        el.cityId=this.addressInformation.cityId
        el.countyId=this.addressInformation.countyId
        el.address=this.addressInformation.detail
        // el.money = this.allPrice
        // el.modifyMoney = this.allPrice
        el.money = el.shopTotalprice
        // el.money = this.allPrice
        el.modifyMoney = el.money

        // if (el.invoiceTitle === '1' || el.invoiceTitle === '2') {
        //   el.simpleInvoice.filter((el) => {
        //     if (el.isDefault === 1) {
        //       this.invoiceId = el.id
        //       this.invoiceTaxId = el.invoiceTaxId
        //     }
        //   })
        //   el.invoiceId = this.invoiceId
        //   el.invoiceTaxId = this.invoiceTaxId
        // }

        if (el.invoiceTitle === '0') {
          el.invoiceName = ''
          el.invoiceTaxId = ''
          el.invoiceId = ''
        }
        el.children.filter((el) => {
          el.shoppingCatId = el.id
          el.partName = el.partComplexName
          el.quantityShipped = el.partNum
          el.partCode = el.oeCode
          el.shouldQuantityShipped = el.quantityShipped
        })
      })
    },

    filterData(data) {
      let list = []
      for (let a = 0; a < data.length; a++) {
        let obj = data[a]
        list[list.length] = obj

        let children = obj.children
        let childrenList = []
        for (let j = 0; j < children.length; j++) {
          if (children[j].partComplexName) {
            childrenList[childrenList.length] = children[j]
          }
        }
        obj.children = childrenList
      }
    },
    changeInput(a){
     a.changeInput = a.formItem.remark.length
    }
  },
  // beforeRouteEnter (to, from, next){
  //   next(vm => {
  //     // 通过 `vm` 访问组件实例,将值传入fromPath
  //     vm.fromPath = from.path
  //   })
  // },
  created() {
    // this.$nextTick(() => {
    //   this.accountAddress()
    //   this.tableList()
    // })
    this.accountAddress()
    this.tableList()
    // this.Reselect()
  }
}
</script>

<style lang="less" scoped>
.reminder{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.box {
  width: 1200px;
  margin: 0 auto;
  .logo {
    width: 150px;
    height: 40px;
    margin-top: 70px;
    margin-bottom: 10px;
    display: inline-block;
    margin-left: 10px;
    img{
      width: 100%;
      height: 100%;
      display: inline-block;
    }
  }
 
  .top {
    margin-top: 34px;
    .top-1 {
      font-weight: 700;
      font-size: 16px;
    }
    .top-2 {
      cursor: pointer;
      float: right;
      color: #377CF1;
    }
  }

  .img {
    float: left;
    width: 80px;
    height: 100px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-right {
    margin-top: 21px;
    display: inline-block;
    width: 250px;

    .tow {
      margin-top: 10px;
      span {
        margin: 0 2px;
      }
      .icon-a-ziyuan5 {
        color: #ff8a24;
      }
      .icon-a-ziyuan4 {
        color: #24b4ff;
      }
      .icon-a-lujing153 {
        color: #47c460;
      }
    }
  }
  .total {
    font-weight: 700;
    font-size: 18px;
    color: black;
    margin-left: 600px;
    span {
      display: inline-block;
      font-weight: 700;
      font-size: 18px;
      color: black;
    }
  }
  .zi {
    width: 300px;
    margin-left: 200px;
  }

  .buttom-one {
    text-align: right;
    line-height: 60px;
    width: 1200px;
    height: 60px;
    border: 1px solid #e2e2e2;
    border-top: none;
    opacity: 1;
    font-size: 20px;
    padding-right: 45px;
    .allPrice {
      color: #505050;
      .price {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .buttom-tow {
    width: 1200px;
    height: 80px;
    border: 2px solid #F62B4E;
    box-sizing: border-box;
    background-color: #ffffff;
    div{
      float: left;
}
    .buttom-sfk {
      height: 100%;
      font-size: 22px;
      display: inline-block;
      padding-left: 50px;
      width: 250px;
      line-height: 80px;
    }
    .buttom-yf {
      display: inline-block;
      width: 270px;
      height: 100%;
      line-height: 78px;
      .buttom-yf-yf {
        color: white;
        font-size: 12px;
        width: 45px;
        height: 16px;
        background: #47c460;
        padding: 0 5px;
        opacity: 1;
        border-radius: 2px;
        margin-right: 5px;
      }

    }
    .buttom-dz {
      text-align: left;
      width: 500px;
      height: 100%;
      overflow: hidden;
      display: inline-block;
      padding-left:30px ;
      /deep/ .ivu-tooltip{
        margin-top: 28px;
        overflow: hidden;
        height: 20px;
        .ivu-tooltip-rel{
          text-align: left;
        }
      }
      .buttom-dz-ps {
        width: 45px;
        height: 16px;
        background: #ff8a24;
        opacity: 1;
        border-radius: 2px;
        font-size: 12px;
        color: white;
        padding: 0 5px;
        margin-right:5px;
      }
    }
    .buttom-tj {
      display: inline-block;
      text-align: center;
      border-radius: 2px;
      color: white;
      height: 100%;
      width: 170px;
      button{
        width:100px;
        height:40px;
        margin-top:15px;
        background: #F62B4E;
        color:#fff;
        border: none;
      }
      button:hover{
        border: none;
        box-sizing: border-box;
        background: red;
      }
      span{
        line-height: 40px;
        text-align: center;
        font-size: 18px;
      }
      // span{
      //   font-weight: 500;
      //   font-size: 18px;
      // }
    }
    // .buttom-jg {
    //   margin-top: 20px;
    //   .icon-a-zu417 {
    //     color: #ff8a24;
    //     margin-right: 5px;
    //     text-align: center;
    //   }
    //   margin-left: 400px;
    //   width: 420px;
    //   font-size: 12px;
    //   height: 24px;
    //   background: #fff8f1;
    //   border: 1px solid #ff8a24;
    //   opacity: 1;
    //   border-radius: 2px;
    //   text-align: center;
    // }
  }
  .Reselect {
    cursor: pointer;
    width: 80px;
    height: 30px;
    border: 1px solid #e90d0d;
    opacity: 1;
    border-radius: 2px;
    margin-top: -50px;
    line-height: 30px;
    right: 70px;
    color: #e90d0d;
    margin-left: 5px;
    margin-right: 10px;
  }
  .f-left {
    color: #B0ADB0;
    margin-left: 60px;
  }
}
.title {
  width: 1200px;
  height: 40px;
  opacity: 1;
  border-radius: 0px;
  line-height: 40px;
  font-weight: 700;
  font-size: 16px;
  padding-left: 10px;
}
.t-top {
  width: 1200px;
  height: 40px;
  font-weight: 700;
  background-color: #F6F6F6;
  div {
    text-align: center;
    display: inline-block;
    height: 40px;
    line-height: 40px;
  }
  .sp {
    width: 567px;
  }
  .fh {
    width: 139px;
  }
  .dj {

    width: 152px;
  }
  .sl {
    width: 120px;
  }
  .sl {
    width: 120px;
  }
  .xj {
    width: 162px;
  }
}
.table {
  .table-top {
    // height: 40px;
    border-bottom: 1px solid #eee;
    line-height: 40px;
    // font-weight: 700;
    border-top: none;
    font-size: 15px;
    .children {
      width: 1200px;
      border: 1px solid #eee;
      // border-top: none;
      border-bottom: none;
      height: 120px;
      display: inline-block;
      background: #ffffff;
      div {
        text-align: center;
        display: inline-block;
        height: 100px;
      }
      .img {
        vertical-align: top;
        display: inline-block;
        width: 90px;
        height: 90px;
        line-height: 80px;
        margin-top: 15px;
        margin-left: 50px;
        margin-right: 40px;
        img {
          vertical-align: top;
          width: 100%;
          height: 100%;
          display: inline-block;
          
        }
      }
      .pjname {
        display: inline-block;
        width: 389px;
        // margin-left: 20px;
        text-align: left;
        .ycj {
          line-height: 16px;
          height: 16px;
          font-size: 12px;
          background-color: #47c460;
          color: #ffffff;
          padding: 0 5px;
          display: inline-block;
          // margin-top: 43px;
        }
        .ad{
        width: 400px;
        word-break: break-word;
        }
  
      }
      .fhaddres {
        width: 140px;
        line-height: 100px;
      }
      .dprice {
        width: 120px;
         line-height: 100px;
      }
      .snumber {
        width: 156px;
         line-height: 100px;
      }
      .xjy {
        width: 120px;
         line-height: 100px;
      }
    }
  }
}
.dphj {
  height: 40px;
  width: 1200px;
  border: 1px solid #eee;
  border-top: none;
  border-bottom: none;
  text-align: right;
  padding-right: 45px;
  color: #505050;
  
}
.ej {
  margin-left: 5px;
  color: #0077ff;
}
.fpxx {
  position: absolute;
  margin-left: 578px;
  margin-top: 100px;
  font-size: 14px;
  color: #505050;
}
.Tips{
    position: absolute;
    left: 330px;
    bottom: 0px;
    font-size: 12px;
    color: gray;
}
.icon-a-lujing162{
  font-size: 16px;
  color: rgb(18, 150, 219);
  margin-left: 4px;
  text-align: center;
}
.fplx{
  margin-right:5px;
  font-size: 12px;
  padding: 0 5px;
  color: #ffffff;
  border-radius: 2px;
}
/deep/ .ivu-form-item-label{
  color: #505050;
  padding-right: 0 !important;
}
.qwer{
  width: 400px;
  height: 30px;
  background: #FFF7F2;
  border: 1px solid #FF5E00;
  opacity: 1;
  border-radius: 2px;
  margin-top: 11px;
  line-height: 30px;
  margin-left: 800px;
}
</style>
